module.exports = __webpack_public_path__ + "img/xp_4.f4770cdf.png";